export default (theme) => ({
  iconTabs: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  iconTab: {
    margin: '0 35px',
    [theme.breakpoints.down('md')]: {
      margin: '0 auto',
    },
  },
  userIcon: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
});
